import { Link } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { PolicyPage, PolicySection } from './PolicyPage'

export const CookieConsent = () => {
  const { t } = useLocalization()

  return (
    <PolicyPage title={t('Cookie policy', 'Cookiepolicy')}>
      <PolicySection title={t('What are cookies?', 'Vad är cookies?')}>
        <p>
          {t(
            'Cookies are small text files stored on your device when you visit a website. Related technologies include local storage, which the browser keeps for the same kind of purpose. This policy explains how Klayder uses them on klayder.com and app.justmerch.co.',
            'Cookies är små textfiler som lagras på din enhet när du besöker en webbplats. Liknande teknik är local storage, som webbläsaren sparar för samma typ av syfte. Den här policyn förklarar hur Klayder använder dem på klayder.com och app.justmerch.co.'
          )}
        </p>
      </PolicySection>

      <PolicySection
        title={t('How we use cookies', 'Hur vi använder cookies')}
      >
        <p>
          {t(
            'We use cookies and local storage so you can sign in, stay signed in, and use the platform. We do not use advertising cookies, and we do not currently run a third-party cookie-consent banner.',
            'Vi använder cookies och local storage så att du kan logga in, förbli inloggad och använda plattformen. Vi använder inte annonscookies, och vi kör för närvarande ingen tredjeparts-cookiebanner.'
          )}
        </p>
      </PolicySection>

      <PolicySection
        title={t('Cookies and storage we use', 'Cookies och lagring vi använder')}
      >
        <ul>
          <li>
            {t(
              'Authentication — Supabase keeps your session (typically in local storage) so magic-link and Google / Microsoft sign-in work. This is necessary for the service.',
              'Autentisering — Supabase sparar din session (vanligtvis i local storage) så att magisk länk och Google- / Microsoft-inloggning fungerar. Detta är nödvändigt för tjänsten.'
            )}
          </li>
          <li>
            {t(
              'Preferences — we store your language choice (English or Swedish) in local storage so the site stays in the language you picked.',
              'Inställningar — vi sparar ditt språkval (engelska eller svenska) i local storage så att sajten håller språket du valt.'
            )}
          </li>
          <li>
            {t(
              'Product use — some screens remember short-lived UI state (for example which chat you last messaged) in local storage. This is not used to advertise to you.',
              'Produktanvändning — vissa vyer minns kortvarigt UI-läge (till exempel vilken chatt du senast skrev i) i local storage. Det används inte för att annonsera till dig.'
            )}
          </li>
        </ul>
        <p>
          {t(
            'If we add analytics or marketing cookies later, we will update this policy and, where required, ask for consent.',
            'Om vi senare lägger till analys- eller marknadsföringscookies uppdaterar vi den här policyn och, där det krävs, ber om samtycke.'
          )}
        </p>
      </PolicySection>

      <PolicySection
        title={t('Managing cookies', 'Hantera cookies')}
      >
        <p>
          {t(
            'You can delete or block cookies and site data in your browser. If you block necessary storage, sign-in and parts of the platform will not work.',
            'Du kan radera eller blockera cookies och webbplatsdata i webbläsaren. Om du blockerar nödvändig lagring fungerar inte inloggning och delar av plattformen.'
          )}
        </p>
        <ul>
          <li>
            Chrome:{' '}
            <a
              href="https://support.google.com/accounts/answer/32050"
              rel="noopener noreferrer"
              target="_blank"
            >
              support.google.com
            </a>
          </li>
          <li>
            Safari:{' '}
            <a
              href="https://support.apple.com/guide/safari/sfri11471/mac"
              rel="noopener noreferrer"
              target="_blank"
            >
              support.apple.com
            </a>
          </li>
          <li>
            Firefox:{' '}
            <a
              href="https://support.mozilla.org/kb/clear-cookies-and-site-data-firefox"
              rel="noopener noreferrer"
              target="_blank"
            >
              support.mozilla.org
            </a>
          </li>
          <li>
            Edge:{' '}
            <a
              href="https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
              rel="noopener noreferrer"
              target="_blank"
            >
              support.microsoft.com
            </a>
          </li>
        </ul>
      </PolicySection>

      <PolicySection title={t('More information', 'Mer information')}>
        <p>
          {t(
            'Personal data processed alongside these technologies is described in our ',
            'Personuppgifter som behandlas tillsammans med dessa tekniker beskrivs i vår '
          )}
          <Link to={paths.privacyPolicy}>
            {t('privacy policy', 'integritetspolicy')}
          </Link>
          {t('. Questions: carmelo@klayder.com.', '. Frågor: carmelo@klayder.com.')}
        </p>
      </PolicySection>
    </PolicyPage>
  )
}
